module.exports = __webpack_public_path__ + "media/images/athletes/3560-6bcb9eff61304bfcf2b20d23c9d00d14.png";